import React from 'react';
import { graphql } from 'gatsby';

import MarketingServicesAndConsulting from '../../../services/marketing-services-and-consulting';
import SEO from 'components/SEO';

import data from '../../../services/marketing-services-and-consulting/data.json';

export default MarketingServicesAndConsulting;

export const Head = ({ location }) => <SEO {...data.head} {...location} />;

export const query = graphql`
  query ($pagePath: String) {
    introImagesJson(page: { eq: $pagePath }) {
      ...IntroImages
    }
  }
`;
